import React from 'react';

import GooglePlay from '@assets/img/google-play-badge.png';
import AppStore from '@assets/svg/app-store-badge.svg';
import TelegramCuttingBotQr from '@assets/svg/TelegramCuttingBotQr.svg';
import TelegramPlantingBotQr from '@assets/svg/TelegramPlantingBotQr.svg';
import MaxCuttingBotQr from '@assets/svg/MaxCuttingBotQr.svg';
import MaxPlantingBotQr from '@assets/svg/MaxPlantingBotQr.svg';

import './not-support.css';

import { MainLogoIcon } from '@icons/index';
import { Flex } from 'antd';

const NotSupport = () => {
    return (
        <div className='not-support'>
            <div className='not-support-title'>
                <MainLogoIcon style={{ fontSize: 64 }} />
            </div>
            <div>
                <div>
                    <a href='https://play.google.com/store/apps/details?id=ru.freshlinecargo.my'>
                        <img style={{ width: 200, height: 85 }} alt='Доступно в Google Play' src={GooglePlay} />
                    </a>
                </div>
                <div style={{ marginTop: 20 }}>
                    <a href='https://apps.apple.com/app/my-freshline/id6642688980'>
                        <img style={{ width: 200 }} alt='Доступно на  App Store' src={AppStore} />
                    </a>
                </div>
                <Flex justify='center' gap='small'>
                    <div style={{ marginTop: 20 }}>
                        <a href='https://t.me/FreshLineCuttingBot'>
                            <img style={{ width: 160 }} alt='Доступно в Telegram' src={TelegramCuttingBotQr} />
                        </a>
                    </div>
                    <div style={{ marginTop: 20 }}>
                        <a href='https://max.ru/id9721145312_1_bot' target='_blank' style={{ color: '#914cf8' }}>
                            <div
                                style={{
                                    maxWidth: 160,
                                    maxHeight: 160,
                                    background: '#ffffff',
                                    padding: '15px 5px 0',
                                    borderRadius: 7,
                                }}
                            >
                                <img style={{ width: 128, marginBottom: -5 }} alt='Доступно в MAX' src={MaxCuttingBotQr} />
                                <span style={{ fontSize: 11 }}>MAXBOTCUTTING</span>
                            </div>
                        </a>
                    </div>
                </Flex>
                <Flex justify='center' gap='small'>
                    <div style={{ marginTop: 20 }}>
                        <a href='https://t.me/FreshLinePlantingBot'>
                            <img style={{ width: 160 }} alt='Доступно в Telegram' src={TelegramPlantingBotQr} />
                        </a>
                    </div>

                    <div style={{ marginTop: 20 }}>
                        <a href='https://max.ru/id9721145312_2_bot' target='_blank' style={{ color: '#914cf8' }}>
                            <div
                                style={{
                                    maxWidth: 160,
                                    maxHeight: 160,
                                    background: '#ffffff',
                                    padding: '15px 5px 0',
                                    borderRadius: 7,
                                }}
                            >
                                <img style={{ width: 128, marginBottom: -5 }} alt='Доступно в MAX' src={MaxPlantingBotQr} />
                                <span style={{ fontSize: 11 }}>MAXBOTPLANTING</span>
                            </div>
                        </a>
                    </div>
                </Flex>
            </div>
        </div>
    );
};

export default NotSupport;
